var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "workflow-template-form-root" },
    [
      _c(
        "samc-modal",
        {
          attrs: { width: "80%", height: "80%", "disable-auto-cancel": "" },
          on: { cancelModal: _setup.handleCancel },
        },
        [
          _c(
            "samc-modal-header",
            {
              attrs: { "enable-close": "" },
              on: { close: _setup.handleCancel },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _setup.isNew
                      ? "New Template"
                      : "Edit Template: " + _setup.templateData.templateName
                  ) +
                  "\n  "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-col gap-6 flex-1 h-[calc(100%-84px)]" },
            [
              _c(
                "div",
                { staticClass: "flex flex-row gap-6" },
                [
                  _c(
                    "div",
                    { staticClass: "flex flex-col flex-grow gap-6" },
                    [
                      _c(
                        "samc-field",
                        {
                          attrs: {
                            label: "Template Name",
                            required: true,
                            disabled: !_setup.canEdit,
                            "error-message": _setup.templateNameError,
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _setup.templateData.templateName,
                                expression: "templateData.templateName",
                              },
                            ],
                            attrs: {
                              type: "text",
                              placeholder: "Enter Template Name",
                              maxlength: 100,
                            },
                            domProps: {
                              value: _setup.templateData.templateName,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _setup.templateData,
                                  "templateName",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "samc-field",
                        {
                          staticClass: "flex flex-row gap-4",
                          attrs: {
                            label: "Acquisition / Sale",
                            id: "asset-type-field",
                            disabled: !_setup.canEdit,
                            value: _setup.templateData.isDeal
                              ? "true"
                              : "false",
                          },
                          on: { valuechanged: _setup.onIsDealChanged },
                        },
                        [
                          _c(
                            "samc-radio",
                            { attrs: { value: "false", name: "assetType" } },
                            [_vm._v("\n            Acquisition\n          ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "samc-radio",
                            { attrs: { value: "true", name: "assetType" } },
                            [_vm._v("\n            Sale\n          ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "samc-field",
                    {
                      staticClass: "flex flex-col flex-grow",
                      attrs: {
                        id: "description-field",
                        label: "Description",
                        required: true,
                        disabled: !_setup.canEdit,
                        "error-message": _setup.descriptionError,
                      },
                    },
                    [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _setup.templateData.description,
                            expression: "templateData.description",
                          },
                        ],
                        staticClass: "flex flex-col flex-grow",
                        attrs: { placeholder: "Enter Description" },
                        domProps: { value: _setup.templateData.description },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _setup.templateData,
                              "description",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "samc-field",
                {
                  staticClass: "flex-1 flex flex-col h-full",
                  attrs: {
                    id: "template-items-field",
                    label: "Template Items",
                    required: true,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex-1 flex flex-col min-h-0" },
                    [
                      _c(
                        "samc-grid-toolbar",
                        [
                          (_setup.isNew &&
                            _setup.entitledToCreateTaskTemplates) ||
                          (!_setup.isNew &&
                            _setup.entitledToEditOrRemoveTaskTemplates)
                            ? _c(
                                "samc-toolbar-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _setup.handleAddTaskItem },
                                },
                                [_c("icon-add"), _vm._v("Add Item")],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("samc-grid", {
                        ref: "gridRef",
                        staticClass: "flex-1 w-full",
                        attrs: {
                          "column-min-width": 100,
                          "row-model-type": "clientSide",
                          "suppress-movable-columns": true,
                        },
                        on: {
                          overridegridoptions: function ($event) {
                            return _setup.overrideGridOptions($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _setup.templateItemsError
                    ? _c(
                        "div",
                        { staticClass: "text-sm text-[#BD0E08] shrink-0" },
                        [_vm._v(_vm._s(_setup.templateItemsError))]
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "samc-modal-actions",
            [
              _c("samc-button", { on: { click: _setup.handleCancel } }, [
                _vm._v("Cancel"),
              ]),
              _vm._v(" "),
              (_setup.isNew && _setup.entitledToCreateTaskTemplates) ||
              (!_setup.isNew && _setup.entitledToEditOrRemoveTaskTemplates)
                ? _c(
                    "samc-button",
                    {
                      attrs: { disabled: _setup.hasErrors, type: "secondary" },
                      on: { click: _setup.handleSave },
                    },
                    [_vm._v("Save")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _setup.validationLimitModalOpen
        ? _c(
            "samc-modal",
            {
              attrs: {
                width: "400px",
                height: "auto",
                "disable-auto-cancel": "",
              },
              on: { cancelModal: _setup.closeValidationLimitModal },
            },
            [
              _c(
                "samc-modal-header",
                {
                  attrs: { "enable-close": "" },
                  on: { close: _setup.closeValidationLimitModal },
                },
                [_vm._v("\n    Validations / Limits\n  ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex flex-col gap-4 p-2" },
                [
                  _c(
                    "samc-field",
                    {
                      staticClass: "flex flex-row gap-4",
                      attrs: {
                        label: "Type",
                        id: "validation-limit-kind-field",
                        disabled: !_setup.canEdit,
                        value:
                          _setup.validationLimitKindForModal === "limit"
                            ? "true"
                            : "false",
                      },
                      on: {
                        valuechanged: _setup.onValidationLimitKindModalChanged,
                      },
                    },
                    [
                      _c(
                        "samc-radio",
                        {
                          attrs: {
                            value: "false",
                            name: "validationLimitKind",
                          },
                        },
                        [_vm._v("Validation")]
                      ),
                      _vm._v(" "),
                      _c(
                        "samc-radio",
                        {
                          attrs: { value: "true", name: "validationLimitKind" },
                        },
                        [_vm._v("Limit")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _setup.validationLimitKindForModal === "validation"
                    ? _c(
                        "div",
                        { staticClass: "flex flex-col gap-2" },
                        [
                          _setup.validationsPickerLoaded
                            ? _c(
                                "samc-dropdown",
                                {
                                  attrs: {
                                    "enable-clear": "",
                                    "enable-search": "",
                                    value: _setup.modalValidationTemplateGuid,
                                    placeholder: "Select validation template…",
                                    disabled: !_setup.canEdit,
                                  },
                                  on: {
                                    searchChanged:
                                      _setup.onValidationSearchChanged,
                                    valueChanged:
                                      _setup.onValidationValueChanged,
                                    selectOption:
                                      _setup.onValidationSelectOption,
                                  },
                                },
                                _vm._l(
                                  _setup.filteredValidationPickerRows,
                                  function (row) {
                                    return _c(
                                      "samc-option",
                                      {
                                        key: row.kind + ":" + row.key,
                                        attrs: {
                                          value:
                                            row.kind === "limit"
                                              ? row.guid
                                              : "folder:" + row.key,
                                          text: row.text,
                                          "has-children": row.kind === "folder",
                                          level: row.level,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n          " +
                                            _vm._s(row.text) +
                                            "\n        "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "flex flex-col gap-2" },
                        [
                          _setup.limitsPickerLoaded
                            ? _c(
                                "samc-dropdown",
                                {
                                  attrs: {
                                    "enable-clear": "",
                                    "enable-search": "",
                                    value: _setup.modalLimitSetId,
                                    placeholder: "Select limit…",
                                    disabled: !_setup.canEdit,
                                  },
                                  on: {
                                    searchChanged: _setup.onLimitSearchChanged,
                                    valueChanged: _setup.onLimitValueChanged,
                                    selectOption: _setup.onLimitSelectOption,
                                  },
                                },
                                _vm._l(
                                  _setup.filteredLimitPickerRows,
                                  function (row) {
                                    return _c(
                                      "samc-option",
                                      {
                                        key: row.kind + ":" + row.key,
                                        attrs: {
                                          value:
                                            row.kind === "limit"
                                              ? row.guid
                                              : "folder:" + row.key,
                                          text: row.text,
                                          "has-children": row.kind === "folder",
                                          level: row.level,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n          " +
                                            _vm._s(row.text) +
                                            "\n        "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "samc-modal-actions",
                [
                  _c(
                    "samc-button",
                    { on: { click: _setup.closeValidationLimitModal } },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _setup.canEdit
                    ? _c(
                        "samc-button",
                        {
                          attrs: { type: "secondary" },
                          on: { click: _setup.applyValidationLimitModal },
                        },
                        [_vm._v("Apply")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }